import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { active: Boolean, url: String, interval: { type: Number, default: 5000 } };

  connect() {
    this.connected = true;
    this.schedule();
  }

  disconnect() {
    this.connected = false;
    window.clearTimeout(this.timer);
  }

  schedule() {
    if (this.connected && this.activeValue) {
      this.timer = window.setTimeout(() => this.refresh(), this.intervalValue);
    }
  }

  async refresh() {
    if (!this.connected || !this.activeValue) return;
    const frame = this.element.closest("turbo-frame");
    if (!frame) return;
    if (document.hidden || frame.hasAttribute("busy")) {
      this.schedule();
      return;
    }

    try {
      const url = new URL(this.urlValue, document.baseURI).href;
      if (frame.src && new URL(frame.src, document.baseURI).href === url) frame.reload();
      else frame.src = url;
      await frame.loaded;
    } catch {
      // Retry on the next interval if a temporary network failure interrupts the frame.
    } finally {
      this.schedule();
    }
  }
}
